<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Nombre" campo="nombre" />
      <th-ordenado class="text-center" titulo="Abreviatura" campo="abreviatura" />
      <th>Símbolo</th>
      <th>Paises</th>
      <th class="th-acciones" width="260">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-if="!divisas" :colspan="4" />
      <tr v-for="divisa in divisas" :key="divisa.id" role="button">
        <td @click="editarDivisa(divisa.id)" nowrap="nowrap">
          {{ divisa.nombre }}
        </td>
        <td class="text-center" @click="editarDivisa(divisa.id)">
          {{ divisa.abreviatura }}
        </td>
        <td class="text-center" @click="editarDivisa(divisa.id)">
          {{ divisa.simbolo }}
        </td>
        <td @click="editarDivisa(divisa.id)">{{ divisa.paises }}</td>
        <td nowrap="nowrap" class="td-acciones-auto">
          <row-menu>
            <row-menu-item @click="editarDivisa(divisa.id)" text="Editar" icon="edit" />
            <row-menu-item @click="editarTasaConversion(divisa.id)" text="Tasas de conversión" icon="percent" />
            <row-menu-divider />
            <row-menu-item @click="eliminarDivisa(divisa.id)" text="Eliminar" icon="trash" />
          </row-menu>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useDivisaListadoStore } from "@/stores/DivisaStore";

export default {
  computed: {
    ...mapState(useDivisaListadoStore, ["divisas"]),
  },
  methods: {
    ...mapActions(useDivisaListadoStore, ["listar", "eliminar"]),
    editarDivisa(divisaId) {
      this.$router.push("/divisas/editar/" + divisaId);
    },
    editarTasaConversion(divisaId) {
      this.$router.push("/divisas/editar-tasas/" + divisaId);
    },
    async eliminarDivisa(divisaId) {
      const ok = await this.$messages.confirm("¿Está seguro de que desea eliminar esta divisa?");
      if (ok) {
        await this.eliminar(divisaId);
        this.$messages.info("Divisa eliminada correctamente");
        this.listar();
      }
    },
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar(this.$route.query);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
